
import React from 'react';
import { Icon } from '../ui';

const TVA_RATES = [0, 7, 13, 19];

const QuoteForm = ({ form, setField, clients, editingQuote, onSubmit, onClose, loading }) => {

  const updateItem = (idx, patch) => {
    const items = [...(form.items || [])];
    items[idx] = { ...items[idx], ...patch };
    setField('items', items);
  };

  const addItem = () => {
    setField('items', [...(form.items || []), { description: '', quantity: 1, priceHT: 0, tvaRate: 19, itemType: 'honoraire' }]);
  };

  const removeItem = (idx) => {
    const items = (form.items || []).filter((_, i) => i !== idx);
    setField('items', items.length ? items : [{ description: '', quantity: 1, priceHT: 0, tvaRate: 19, itemType: 'honoraire' }]);
  };

  const computeLine = (it) => {
    const qty  = Number(it.quantity) || 0;
    const prix = Number(it.priceHT)  || 0;
    const tva  = Number(it.tvaRate)  || 0;
    const tHT  = qty * prix;
    const tTVA = tHT * tva / 100;
    return { tHT, tTVA, tTTC: tHT + tTVA };
  };

  const totals = (form.items || []).reduce((acc, it) => {
    const { tHT, tTVA, tTTC } = computeLine(it);
    return { totalHT: acc.totalHT + tHT, totalTVA: acc.totalTVA + tTVA, totalTTC: acc.totalTTC + tTTC };
  }, { totalHT: 0, totalTVA: 0, totalTTC: 0 });
  const grandTotal = totals.totalTTC + Number(form.timbreFiscal || 1);

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-5xl flex flex-col" style={{ maxHeight: 'calc(100vh - 2rem)' }}>

        <div className="flex items-center justify-between px-6 py-4 border-b shrink-0">
          <h2 className="text-lg font-bold text-gray-800">{editingQuote ? 'Modifier le devis' : 'Nouveau devis'}</h2>
          <button onClick={onClose} className="p-2 text-gray-400 hover:text-gray-600 rounded-lg" type="button">
            <Icon name="IconX" />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto px-6 py-4">
          <form onSubmit={onSubmit} className="space-y-5">

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div>
                <label className="block text-sm font-medium mb-1 text-gray-700">Client *</label>
                <select value={form.clientId} onChange={e => setField('clientId', e.target.value)}
                  className="w-full p-3 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500" required>
                  <option value="">-- Selectionner --</option>
                  {clients.map(c => <option key={c._id || c.id} value={c._id || c.id}>{c.companyName || c.name}</option>)}
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium mb-1 text-gray-700">Date devis *</label>
                <input type="date" value={form.quoteDate} onChange={e => setField('quoteDate', e.target.value)}
                  className="w-full p-3 border border-gray-300 rounded-lg text-sm" required />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1 text-gray-700">Valide jusqu'au</label>
                <input type="date" value={form.validUntil} onChange={e => setField('validUntil', e.target.value)}
                  className="w-full p-3 border border-gray-300 rounded-lg text-sm" />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1 text-gray-700">Statut</label>
                <select value={form.status} onChange={e => setField('status', e.target.value)}
                  className="w-full p-3 border border-gray-300 rounded-lg text-sm">
                  <option value="DRAFT">DRAFT</option>
                  <option value="SENT">SENT</option>
                  <option value="ACCEPTED">ACCEPTED</option>
                  <option value="REFUSED">REFUSED</option>
                  <option value="EXPIRED">EXPIRED</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium mb-1 text-gray-700">Timbre fiscal (DT)</label>
                <input type="number" step="0.001" value={form.timbreFiscal}
                  onChange={e => setField('timbreFiscal', e.target.value)}
                  className="w-full p-3 border border-gray-300 rounded-lg text-sm" />
              </div>
            </div>

            <div className="bg-gray-50 border rounded-lg p-4">
              <div className="flex items-center justify-between mb-3">
                <h3 className="font-semibold text-gray-800">Lignes</h3>
                <button type="button" onClick={addItem}
                  className="inline-flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium text-blue-700 bg-blue-50 border border-blue-200 rounded-lg hover:bg-blue-100">
                  <Icon name="IconPlus" size={14} /> Ajouter ligne
                </button>
              </div>
              <div className="space-y-3">
                {(form.items || []).map((it, idx) => {
                  const { tHT, tTTC } = computeLine(it);
                  return (
                    <div key={idx} className="bg-white border rounded-lg p-3">
                      <div className="grid grid-cols-12 gap-2 items-end">
                        <div className="col-span-5">
                          <label className="block text-xs font-medium mb-1 text-gray-600">Description</label>
                          <input value={it.description} onChange={e => updateItem(idx, { description: e.target.value })}
                            className="w-full p-2 border border-gray-300 rounded text-sm" placeholder="Description..." required />
                        </div>
                        <div className="col-span-1">
                          <label className="block text-xs font-medium mb-1 text-gray-600">Qte</label>
                          <input type="number" min="0" step="1" value={it.quantity} onChange={e => updateItem(idx, { quantity: e.target.value })}
                            className="w-full p-2 border border-gray-300 rounded text-sm" />
                        </div>
                        <div className="col-span-2">
                          <label className="block text-xs font-medium mb-1 text-gray-600">PU HT</label>
                          <input type="number" step="0.001" value={it.priceHT} onChange={e => updateItem(idx, { priceHT: e.target.value })}
                            className="w-full p-2 border border-gray-300 rounded text-sm" />
                        </div>
                        <div className="col-span-1">
                          <label className="block text-xs font-medium mb-1 text-gray-600">TVA %</label>
                          <select value={it.tvaRate} onChange={e => updateItem(idx, { tvaRate: e.target.value })}
                            className="w-full p-2 border border-gray-300 rounded text-sm">
                            {TVA_RATES.map(r => <option key={r} value={r}>{r}%</option>)}
                          </select>
                        </div>
                        <div className="col-span-2">
                          <label className="block text-xs font-medium mb-1 text-gray-600">Total TTC</label>
                          <div className="p-2 bg-blue-50 border border-blue-200 rounded text-sm font-semibold text-blue-800">
                            {tTTC.toFixed(3)} DT
                          </div>
                        </div>
                        <div className="col-span-1 flex justify-end">
                          <button type="button" onClick={() => removeItem(idx)}
                            className="p-2 text-red-600 hover:bg-red-50 rounded">
                            <Icon name="IconTrash" size={14} />
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            <div className="bg-gray-50 border rounded-lg p-4 space-y-2">
              <div className="flex justify-between text-sm"><span className="text-gray-600">Total HT</span><span className="font-medium">{totals.totalHT.toFixed(3)} DT</span></div>
              <div className="flex justify-between text-sm"><span className="text-gray-600">Total TVA</span><span className="font-medium">{totals.totalTVA.toFixed(3)} DT</span></div>
              <div className="flex justify-between text-sm"><span className="text-gray-600">Total TTC</span><span className="font-medium">{totals.totalTTC.toFixed(3)} DT</span></div>
              <div className="flex justify-between text-sm"><span className="text-gray-600">Timbre fiscal</span><span className="font-medium">{Number(form.timbreFiscal || 1).toFixed(3)} DT</span></div>
              <div className="flex justify-between font-bold text-blue-800 text-base border-t pt-2">
                <span>TOTAL</span><span>{grandTotal.toFixed(3)} DT</span>
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium mb-1 text-gray-700">Notes</label>
              <textarea value={form.notes} onChange={e => setField('notes', e.target.value)}
                className="w-full p-3 border border-gray-300 rounded-lg text-sm" rows={3} placeholder="Remarques..." />
            </div>

            <div className="flex justify-end gap-2 pt-2 border-t">
              <button type="button" onClick={onClose} className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50" disabled={loading}>Annuler</button>
              <button type="submit" className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700" disabled={loading}>
                {loading ? 'Enregistrement...' : 'Enregistrer'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default QuoteForm;
